import { DisplayData } from '../../helpers/Controls';
import { UnitedStatesIso3, CanadaIso3 } from '../Country/Country';

export interface DisplayDataStateProvince extends DisplayData {
  country: string;
}

const stateProvincesOptions: DisplayDataStateProvince[] = [
  // USA States and Territories
  {
    display: 'Alabama',
    data: 'AL',
    country: UnitedStatesIso3,
  },
  {
    display: 'Alaska',
    data: 'AK',
    country: UnitedStatesIso3,
  },
  /*
  {
    display: 'American Samoa',
    data: 'AS',
    country: UnitedStatesIso3,
  },
  */
  {
    display: 'Arizona',
    data: 'AZ',
    country: UnitedStatesIso3,
  },
  {
    display: 'Arkansas',
    data: 'AR',
    country: UnitedStatesIso3,
  },
  {
    display: 'California',
    data: 'CA',
    country: UnitedStatesIso3,
  },
  {
    display: 'Colorado',
    data: 'CO',
    country: UnitedStatesIso3,
  },
  {
    display: 'Connecticut',
    data: 'CT',
    country: UnitedStatesIso3,
  },
  {
    display: 'Delaware',
    data: 'DE',
    country: UnitedStatesIso3,
  },
  /*
  {
    display: 'District Of Columbia',
    data: 'DC',
    country: UnitedStatesIso3,
  },
  */
  /*
  {
    display: 'Federated States Of Micronesia',
    data: 'FM',
    country: UnitedStatesIso3,
  },
  */
  {
    display: 'Florida',
    data: 'FL',
    country: UnitedStatesIso3,
  },
  {
    display: 'Georgia',
    data: 'GA',
    country: UnitedStatesIso3,
  },
  /*
  {
    display: 'Guam',
    data: 'GU',
    country: UnitedStatesIso3,
  },
  */
  {
    display: 'Hawaii',
    data: 'HI',
    country: UnitedStatesIso3,
  },
  {
    display: 'Idaho',
    data: 'ID',
    country: UnitedStatesIso3,
  },
  {
    display: 'Illinois',
    data: 'IL',
    country: UnitedStatesIso3,
  },
  {
    display: 'Indiana',
    data: 'IN',
    country: UnitedStatesIso3,
  },
  {
    display: 'Iowa',
    data: 'IA',
    country: UnitedStatesIso3,
  },
  {
    display: 'Kansas',
    data: 'KS',
    country: UnitedStatesIso3,
  },
  {
    display: 'Kentucky',
    data: 'KY',
    country: UnitedStatesIso3,
  },
  {
    display: 'Louisiana',
    data: 'LA',
    country: UnitedStatesIso3,
  },
  {
    display: 'Maine',
    data: 'ME',
    country: UnitedStatesIso3,
  },
  /*
  {
    display: 'Marshall Islands',
    data: 'MH',
    country: UnitedStatesIso3,
  },
  */
  {
    display: 'Maryland',
    data: 'MD',
    country: UnitedStatesIso3,
  },
  {
    display: 'Massachusetts',
    data: 'MA',
    country: UnitedStatesIso3,
  },
  {
    display: 'Michigan',
    data: 'MI',
    country: UnitedStatesIso3,
  },
  {
    display: 'Minnesota',
    data: 'MN',
    country: UnitedStatesIso3,
  },
  {
    display: 'Mississippi',
    data: 'MS',
    country: UnitedStatesIso3,
  },
  {
    display: 'Missouri',
    data: 'MO',
    country: UnitedStatesIso3,
  },
  {
    display: 'Montana',
    data: 'MT',
    country: UnitedStatesIso3,
  },
  {
    display: 'Nebraska',
    data: 'NE',
    country: UnitedStatesIso3,
  },
  {
    display: 'Nevada',
    data: 'NV',
    country: UnitedStatesIso3,
  },
  {
    display: 'New Hampshire',
    data: 'NH',
    country: UnitedStatesIso3,
  },
  {
    display: 'New Jersey',
    data: 'NJ',
    country: UnitedStatesIso3,
  },
  {
    display: 'New Mexico',
    data: 'NM',
    country: UnitedStatesIso3,
  },
  {
    display: 'New York',
    data: 'NY',
    country: UnitedStatesIso3,
  },
  {
    display: 'North Carolina',
    data: 'NC',
    country: UnitedStatesIso3,
  },
  {
    display: 'North Dakota',
    data: 'ND',
    country: UnitedStatesIso3,
  },
  /*
  {
    display: 'Northern Mariana Islands',
    data: 'MP',
    country: UnitedStatesIso3,
  },
  */
  {
    display: 'Ohio',
    data: 'OH',
    country: UnitedStatesIso3,
  },
  {
    display: 'Oklahoma',
    data: 'OK',
    country: UnitedStatesIso3,
  },
  {
    display: 'Oregon',
    data: 'OR',
    country: UnitedStatesIso3,
  },
  /*
  {
    display: 'Palau',
    data: 'PW',
    country: UnitedStatesIso3,
  },
  */
  {
    display: 'Pennsylvania',
    data: 'PA',
    country: UnitedStatesIso3,
  },
  {
    display: 'Puerto Rico',
    data: 'PR',
    country: UnitedStatesIso3,
  },
  {
    display: 'Rhode Island',
    data: 'RI',
    country: UnitedStatesIso3,
  },
  {
    display: 'South Carolina',
    data: 'SC',
    country: UnitedStatesIso3,
  },
  {
    display: 'South Dakota',
    data: 'SD',
    country: UnitedStatesIso3,
  },
  {
    display: 'Tennessee',
    data: 'TN',
    country: UnitedStatesIso3,
  },
  {
    display: 'Texas',
    data: 'TX',
    country: UnitedStatesIso3,
  },
  {
    display: 'Utah',
    data: 'UT',
    country: UnitedStatesIso3,
  },
  {
    display: 'Vermont',
    data: 'VT',
    country: UnitedStatesIso3,
  },
  /*
  {
    display: 'Virgin Islands',
    data: 'VI',
    country: UnitedStatesIso3,
  },
  */
  {
    display: 'Virginia',
    data: 'VA',
    country: UnitedStatesIso3,
  },
  {
    display: 'Washington',
    data: 'WA',
    country: UnitedStatesIso3,
  },
  {
    display: 'West Virginia',
    data: 'WV',
    country: UnitedStatesIso3,
  },
  {
    display: 'Wisconsin',
    data: 'WI',
    country: UnitedStatesIso3,
  },
  {
    display: 'Wyoming',
    data: 'WY',
    country: UnitedStatesIso3,
  },
  // Canadian Provinces
  {
    display: 'Alberta',
    data: 'AB',
    country: CanadaIso3,
  },
  {
    display: 'British Columbia',
    data: 'BC',
    country: CanadaIso3,
  },
  {
    display: 'Manitoba',
    data: 'MB',
    country: CanadaIso3,
  },
  {
    display: 'New Brunswick',
    data: 'NB',
    country: CanadaIso3,
  },
  {
    display: 'Newfoundland and Labrador',
    data: 'NL',
    country: CanadaIso3,
  },
  {
    display: 'Northwest Territories',
    data: 'NT',
    country: CanadaIso3,
  },
  {
    display: 'Nova Scotia',
    data: 'NS',
    country: CanadaIso3,
  },
  {
    display: 'Nunavut',
    data: 'NU',
    country: CanadaIso3,
  },
  {
    display: 'Ontario',
    data: 'ON',
    country: CanadaIso3,
  },
  {
    display: 'Prince Edward Island',
    data: 'PE',
    country: CanadaIso3,
  },
  {
    display: 'Quebec',
    data: 'QC',
    country: CanadaIso3,
  },
  {
    display: 'Saskatchewan',
    data: 'SK',
    country: CanadaIso3,
  },
  {
    display: 'Yukon Territory',
    data: 'YT',
    country: CanadaIso3,
  },
];

// eslint-disable-next-line arrow-body-style
const compareDisplayDataStateProvince = (value1: DisplayDataStateProvince, value2: DisplayDataStateProvince): number => {
  return value1.display.localeCompare(value2.display);
};

export function getStateProvinces(country: string): DisplayData[] {
  // Filter State / provinces by Country
  if (country) {
    return stateProvincesOptions.filter((stateProvinceOption: DisplayDataStateProvince) => stateProvinceOption.country === country);
  }

  // Sort the List as the States / provinces are from various Countries
  return stateProvincesOptions.sort(compareDisplayDataStateProvince);
}

export function stateProvinceNameToAbbreviation(stateProvince: string): string {
  if (stateProvince) {
    const stateProvinces: DisplayDataStateProvince[] = stateProvincesOptions
      .filter((stateProvinceOption: DisplayDataStateProvince) => stateProvinceOption.display === stateProvince);

    if (stateProvinces.length > 0) {
      return stateProvinces[0].data;
    }
  }

  return stateProvince;
}

export function stateProvinceAbbreviationToName(stateProvince: string): string {
  if (stateProvince) {
    const stateProvinces: DisplayDataStateProvince[] = stateProvincesOptions
      .filter((stateProvinceOption: DisplayDataStateProvince) => stateProvinceOption.data === stateProvince);

    if (stateProvinces.length > 0) {
      return stateProvinces[0].display;
    }
  }

  return stateProvince;
}

export function stateProvinceAbbreviationToObject(stateProvince: string): DisplayDataStateProvince {
  if (stateProvince) {
    const stateProvinces: DisplayDataStateProvince[] = stateProvincesOptions
      .filter((stateProvinceOption: DisplayDataStateProvince) => stateProvinceOption.data === stateProvince);

    if (stateProvinces.length > 0) {
      return stateProvinces[0];
    }
  }

  return null;
}
